export default __webpack_public_path__ + "static/019-ba628e02da256f10e8f7261587961d78.jpg";